import React from "react";
import ColophonTable from "../../components/tables/ColophonTable";
import { Box, Button, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";

const MainColophonPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <Box
        sx={{
          mb: 4,
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Button
          variant="contained"
          color="primary"
          sx={{
            position: "absolute",
            left: 16,
          }}
          startIcon={<AddIcon />}
          onClick={() => navigate("create")}
        >
          Create Colophon
        </Button>
        <Typography variant="h1">Colophons</Typography>
      </Box>
      <ColophonTable />
    </Box>
  );
};

export default MainColophonPage;
